import $ from "jquery";
import "../bootstrap.js";
window.$ = $;
window.jQuery = $;

document.addEventListener("DOMContentLoaded", async () => {
    const equipmentEls = document.querySelectorAll(".js-equipment-slider");
    const { renderEquipmentSlider } = await import("../components/slider.js");
    equipmentEls.forEach((el) => {
        renderEquipmentSlider(el);
    });

    const anchorEl = document.querySelectorAll(".handle-anchor");
    if (anchorEl) {
        const { initAnchorLink } = await import("../components/anchorlink.js");
        initAnchorLink();
    }
});
